import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  // DialogTitle,
} from '@headlessui/react'
import { type TCDialog } from 'core/interface/CDialog'
import Button from './../form-controls/Button'
import { _t } from "core/language";
import CloseIcon from 'core/assets/icons/commons/icon_close.svg';

export default function CDialog({
  open,
  closeModal,
  children,
  submitText,
  closeText,
  handleSubmit,
  onCancel,
  title,
  classNamechildren,
  isButton = true,
  buttonSize = 'sm',
  hideCancel = false,
  classBtnSubmit,
  classBtn = '',
  hideClose,
  disableCloseOnBackDrop = false,
}: TCDialog) {

  const _onClose = () => {
    closeModal?.()
    onCancel?.()
  }

  const _handleSubmit = () => {
    handleSubmit?.()
    closeModal?.()
  }

  return (
    <Dialog open={open} onClose={() => !disableCloseOnBackDrop ? closeModal?.() : {}} className="relative z-[300]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-[#00000080] bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <DialogPanel
            transition
            className="relative transform w-full overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="flex justify-between items-center h-[30px]">
              <h2 className="text-xl font-semibold">{_t(title || '')}</h2>
              {
                !hideClose && <button className="text-gray-400 hover:text-gray-600 absolute right-2 top-2" onClick={_onClose}>
                  <img src={CloseIcon} className='' alt="close" />
                </button>
              }
            </div>

            <div className={`bg-white px-4 py-[30px] sm:p-6 sm:pb-4 text-lg font-medium text-center ${classNamechildren}`}>
              {children}
            </div>
            {isButton && <div className=" px-4 pb-[40px] w-full flex justify-center gap-2">
              {!hideCancel ? <Button
                type="button"
                label={_t(closeText || "common.cancel")}
                onClickBtn={_onClose}
                size={buttonSize}
                classBtn={`min-w-[104px] ${classBtn}`}
              /> : null}
              <Button
                type="button"
                label={_t(submitText || 'common.ok')}
                onClickBtn={_handleSubmit}
                size={buttonSize}
                classBtn={`min-w-[104px] ${classBtnSubmit} ${classBtn}`}
              />
            </div>}
            
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
